import { io } from "socket.io-client";

import { API_URL } from "src/Common/function";
import { getActiveCompany } from "src/Common/tenant";
import TokenService from "src/Services/API/token.service";

// The backend's /wo-activity namespace: "wo-customer-activity" { woId, kind }
// when a customer creates a request or signs / declines a proposal. Joins the
// company the app is working in (a Super Admin's entered tenant included) on
// every (re)connect.
let socket;

const getWoActivitySocket = () => {
  if (!socket) {
    socket = io(`${API_URL}/wo-activity`, {
      autoConnect: false,
      transports: ["websocket"],
      auth: (cb) => cb({ token: TokenService.getLocalAccessToken() }),
    });
    socket.on("connect", () => {
      const company = getActiveCompany();
      if (company) socket.emit("wo-activity:join", { company });
    });
  }
  if (!socket.connected && TokenService.getLocalAccessToken()) {
    socket.connect();
  }
  return socket;
};

// Entering or leaving a tenant changes the company; join the new one.
const rejoinWoActivityCompany = () => {
  const company = getActiveCompany();
  if (socket?.connected && company) socket.emit("wo-activity:join", { company });
};

export { getWoActivitySocket, rejoinWoActivityCompany };
